import React from 'react';

import { coreTranslations } from 'translations';

import featureService from '@services/feature.service';
import PermissionService from '@services/permission.service';

import { AlertModuleImage, SharedMessageBoardsImage } from '@components/GlobalSearch/Images/index';


const permissionService = new PermissionService();
const {
    canViewLabels,
    canViewAlertOptions,
    canViewDivisionANI,
    canViewCallThrottling,
    canViewSuppressedAlert,
    canViewManageBlockedSMS,
    canViewAllowedSMS,
    canViewAssignSmsProfiles,
    canViewEditTSSVoices,
    canEditPronunciation,
    canViewDuplicateFilters,
    canViewAlertRetrieval
} = permissionService.permissions;

const alertModulePermissions = [
    canViewLabels(),
    canViewAlertOptions(),
    canViewDivisionANI(),
    canViewCallThrottling(),
    canViewSuppressedAlert(),
    canViewManageBlockedSMS(),
    canViewAllowedSMS(),
    canViewAssignSmsProfiles(),
    canViewEditTSSVoices(),
    canEditPronunciation(),
    canViewDuplicateFilters(),
    canViewAlertRetrieval()
];

const canViewAlertModuleTile = () => alertModulePermissions.some(permission => !!permission);

export const tilesConfig = [
    {
        title: coreTranslations.ng_core_alertModule,
        description: coreTranslations.ng_core_alertModuleDescription,
        path: '/alert-module',
        icon: <AlertModuleImage color="primary" />,
        visible: () => canViewAlertModuleTile()
    },
    {
        title: coreTranslations.ng_core_sharedMessageBoards,
        description: coreTranslations.ng_core_sharedMessageBoardsDescription,
        path: '/shared-message-board',
        icon: <SharedMessageBoardsImage color="primary" />,
        visible: () => featureService.getFeature('sharedMessageBoards')
    }
];
